import React from 'react';
import { FlexRow } from '@make-software/tg-mini-app-ui';

import { StyledEarnIcon } from '@/shared'
import EarnIcon from '@/shared/assets/icons/ic-earn.svg';

import { AmountBoxContainer, AmountText } from '../styled';

interface IAmountBoxProps {
  amount: number | string;
  onSelectAmount: (amount: number) => void;
  selected: boolean;
  currentRound?: number;
}

export const AmountBox: React.FC<IAmountBoxProps> = ({
  amount,
  onSelectAmount,
  selected,
  currentRound = 1
}) => {
  return (
    <AmountBoxContainer
      justify="center"
      align="center"
      gap={4}
      onClick={() => onSelectAmount(typeof amount === 'string' ? 0 : Number(amount))}
      selected={selected}
    >
      <FlexRow align="center" gap={5}>
        {typeof amount !== 'string' && (
          <StyledEarnIcon src={EarnIcon} fillColor={currentRound === 1 ? '#FB6F6A' : '#A0B3FF'} />
        )}
        <AmountText weight={3} size="lg" selected={selected}>
          {amount}
        </AmountText>
      </FlexRow>
    </AmountBoxContainer>
  );
};
